<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'ESTRUCTURAFISICA.LBL_ESTRUCTURA' | translate}}</h1>
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-6 lg:col-6">
  </div>
  <div class="col-12 md:col-6 lg:col-6">
    <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
           (input)="dt.filterGlobal($event.target.value, 'contains')"
           [(ngModel)]="busqueda" (change)="setBusqueda()">
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas" [loading]="carEstructuraFisica" #dt
             [value]="estFisica" selectionMode="single" dataKey="idEstructuraFisica"
             [paginator]="true" [rows]="10"  paginatorPosition="bottom">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td>{{row.codigo}}</td>
          <td>{{row.estructuraFisica}}</td>
          <td>{{row.categoria}}</td>
          <td>{{row.direccion}}</td>
          <td>{{row.nroZonas}}</td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorVirtual" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                      title="{{'BTN_VISUALIZAR' | translate}}"
                      pButton (click)="verEstructura(row)"></button>
              <button type="button" class="p-button p-button-success btn" icon="fa fa-globe" data-toggle="tooltip"
                      title="{{'ESTRUCTURAFISICA.BTN_ASIGNARZONA' | translate}}" *ngIf="menu.editar && nivUsuario>2 && menZonas.ver"
                      pButton (click)="asignarZona(row)"></button>
              <button type="button" class="p-button p-button-danger btn" icon="fa fa-street-view" data-toggle="tooltip"
                      title="{{'ESTRUCTURAFISICA.BTN_ASIGNAREJECUTIVO' | translate}}" *ngIf="menu.editar && nivUsuario>2"
                      pButton (click)="asignarEjecutivo(row)"></button>
              <button type="button" class="p-button btn" icon="fa fa-building-o" data-toggle="tooltip"
                      title="{{'ESTRUCTURAFISICA.BTN_ASIGNAROFICINA' | translate}}"
                      pButton (click)="asignarOficina(row)"></button>
              <button type="button" class="p-button btn" icon="fa fa-users" data-toggle="tooltip"
                      title="{{'ESTRUCTURAFISICA.BTN_ASIGNARGRUPOS' | translate}}" *ngIf="menu.editar && menGrupos.ver"
                      pButton (click)="asignarGrupo(row)"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ 'MSG_NOHAYREGISTROS' | translate}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
